import HtmlLink from './html/Link';

/**
 * HTML `<button>` disguised as a Link.
 */
export default HtmlLink.withComponent('button');
